export enum BrowserDownloadPageEnum {
  Chrome = 'https://www.google.com/chrome/downloads/',
  Firefox = 'https://www.mozilla.org/en-US/firefox/new/?redirect_source=getfirefox-com',
  Edge = 'https://www.microsoft.com/en-us/edge',
  Safari = 'https://support.apple.com/downloads/safari'
}
